/** Empty-state demo: tapping the sample save icon shows what saving looks like, then resets. */
const RESET_MS = 2200;
const timers = new WeakMap();

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-pag-wl-demo-btn]') : null;
  if (!button) return;

  const demo = button.closest('[data-pag-wl-demo]');
  const hint = demo?.querySelector('[data-pag-wl-demo-hint]');
  if (!demo || !hint) return;

  const saved = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(saved));
  demo.classList.toggle('is-saved', saved);
  hint.textContent = saved ? 'Saved! Do this on any product.' : 'Try it: tap the icon';

  clearTimeout(timers.get(demo));
  if (saved) {
    timers.set(demo, setTimeout(() => {
      button.setAttribute('aria-pressed', 'false');
      demo.classList.remove('is-saved');
      hint.textContent = 'Try it: tap the icon';
    }, RESET_MS));
  }
});
